import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(private authService: AuthService,
    private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> {
    return new Observable(subscriber => {
      console.debug('AuthGuard waiting on isLoggedIn')
      const authsub = this.authService.isLoggedIn.subscribe({
        next: (v) => {
          console.debug('AuthGuard isLoggedIn returned', v)
          if (v === true) {
            subscriber.next(true)
            subscriber.complete()
          }
          else if (v === false) {
            // this event actually means there is no token
            console.debug('AuthGuard not logged in - redirecting to landing')
            subscriber.next(this.router.parseUrl('/landing'))
            subscriber.complete()
          }
          else {
            console.debug('AuthGuard waiting for isLoggedIn')
          }
        }
      })
      // teardown logic is needed to unsubscribe from the auth service
      return () => {
        console.debug('AuthGuard teardown - unsubscribing from auth service')
        authsub.unsubscribe()
      }
    })
  }
}
